import { render, staticRenderFns } from "./infrastructure_title.vue?vue&type=template&id=af9b2c04&"
import script from "./infrastructure_title.vue?vue&type=script&lang=js&"
export * from "./infrastructure_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports